import React, {useCallback, useMemo, useState} from 'react';
import Alert from '../../shared-components/elements/alert/Alert';
import EntityPeekModal from './EntityPeekModal';

export function ListComponent({
    tableFormatter,
    entityType,
    entitiesState,
    entityClick,
    entityPostprocess,
    currentSort,
    doSetSort,
    doLoadMore,
    markedRows,
    showContextMenu,
    filterFormatters,
    filterOnField,
    List,
    t,
}) {
    let [peek, setPeek] = useState(null);

    const postProcessedEntities = useMemo(
        () => (entityPostprocess ? entitiesState.entities.map(entityPostprocess) : entitiesState.entities),
        [entitiesState.entities, entityPostprocess],
    );

    const entityPeek = useCallback(
        (entityTypeId, entity, entityLink) => {
            setPeek({entity, entityLink});
        },
        [setPeek],
    );

    if (tableFormatter == null) {
        return (
            <>
                <Alert>
                    {t('entitiesList.error')} {entityType.dataTypeId}
                </Alert>
                <pre>{JSON.stringify(entitiesState.entities, null, 4)}</pre>
            </>
        );
    }

    return (
        <>
            {peek && (
                <EntityPeekModal
                    entityType={entityType}
                    entity={peek.entity}
                    entityLink={peek.entityLink}
                    hide={() => setPeek(null)}
                />
            )}
            <List.Formatter
                entityType={entityType}
                formatter={tableFormatter}
                entitiesState={entitiesState}
                entities={postProcessedEntities}
                entityClick={entityClick}
                entityPeek={entityPeek}
                currentSort={currentSort}
                setSort={doSetSort}
                loadMore={doLoadMore}
                markedRows={markedRows}
                showContextMenu={showContextMenu}
                filterFormatters={filterFormatters}
                filterOnField={filterOnField}
            />
        </>
    );
}
